import {style} from 'typestyle'
import * as csstips from 'csstips'

export const MainStackBlock = style({
    paddingLeft: 15,
    paddingRight: 15
})

export const titleName = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    marginTop: 15,
    marginBottom: 14
})

export const MainStackBlockWrap = style({
    position: 'relative',
    ...csstips.flexRoot,
    background: '#ffffff',
    paddingBottom: 25,
    marginTop: 15
})

export const leftStackBlock = style({
    width: '48.4%',
    position: 'relative',
    marginRight: 5
})

export const rightStackBlock = style({
    width: '49.8%',
    position: 'relative',
    overflow: 'hidden'
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeStackBlock/HomeStackBlock.style.ts